import { useSearchDebounce } from 'hooks/useSearchDebounce';
import { useTranslation } from 'libs/i18n';
import { Pressed } from 'libs/ui';
import { Icon } from 'libs/ui/Icon';
import { Colors } from 'libs/ui/theme';

import { InputStyped } from './styles';

export interface SearchBarProps {
  search: string;
  className?: string;
  fullWidth?: boolean;
  onSearch: (v: string) => void;
}

export const SearchBar = ({
  search: initialSearch,
  onSearch,
  className,
  fullWidth,
}: SearchBarProps) => {
  const { t } = useTranslation();

  const { search, setSearch, onChangeText } = useSearchDebounce({
    initialSearch,
    onSearch,
  });

  const onClear = () => {
    setSearch('');
    onSearch('');
  };

  return (
    <InputStyped
      className={className}
      fullWidth={fullWidth}
      leftElement={<Icon.Search color={Colors.gray600} size={16} />}
      placeholder={t('common.search')}
      rightStartElement={
        search ? (
          <Pressed onClick={onClear}>
            <Icon.Close color={Colors.gray600} size={16} />
          </Pressed>
        ) : undefined
      }
      value={search}
      onChangeText={onChangeText}
      onSubmit={() => onSearch(search)}
    />
  );
};
